import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "#4eb380",
  class: "bi bi-house-fill",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  d: "m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
}, null, -1)
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-caret-down-fill",
  viewBox: "0 0 16 16"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("path", { d: "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" }, null, -1)
const _hoisted_6 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "green",
  class: "bi bi-check-lg",
  viewBox: "0 0 16 16"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("path", { d: "M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.82-8.69a.486.486 0 0 1 .04-.045z" }, null, -1)
const _hoisted_8 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-plus-lg",
  viewBox: "0 0 16 16"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("path", { d: "M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z" }, null, -1)
const _hoisted_10 = {
  key: 4,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash-fill",
  viewBox: "0 0 16 16"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("path", { d: "M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" }, null, -1)
const _hoisted_12 = {
  key: 5,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-search",
  viewBox: "0 0 16 16"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("span", null, [
    (_ctx.name === _ctx.svgNames.home)
      ? (_openBlock(), _createBlock("svg", _hoisted_1, [
          _hoisted_2,
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_ctx.name === _ctx.svgNames.downArrow)
      ? (_openBlock(), _createBlock("svg", _hoisted_4, [
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (_ctx.name === _ctx.svgNames.checkbox)
      ? (_openBlock(), _createBlock("svg", _hoisted_6, [
          _hoisted_7
        ]))
      : _createCommentVNode("", true),
    (_ctx.name === _ctx.svgNames.plus)
      ? (_openBlock(), _createBlock("svg", _hoisted_8, [
          _hoisted_9
        ]))
      : _createCommentVNode("", true),
    (_ctx.name === _ctx.svgNames.delete)
      ? (_openBlock(), _createBlock("svg", _hoisted_10, [
          _hoisted_11
        ]))
      : _createCommentVNode("", true),
    (_ctx.name === _ctx.svgNames.search)
      ? (_openBlock(), _createBlock("svg", _hoisted_12, [
          _hoisted_13
        ]))
      : _createCommentVNode("", true)
  ]))
}